import { render } from "./PregnancyWeeksSwiper.vue?vue&type=template&id=2d1245cc&scoped=true"
import script from "./PregnancyWeeksSwiper.vue?vue&type=script&lang=js"
export * from "./PregnancyWeeksSwiper.vue?vue&type=script&lang=js"

import "./PregnancyWeeksSwiper.vue?vue&type=style&index=0&id=2d1245cc&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d1245cc"]])

export default __exports__